<template>
  <div
    v-if="showItem"
    :style="{ width: widthItem }"
  >
    <slot name="content" />
  </div>
</template>

<script>

export default {
  props: {
    widthMobile: { type: Number, default: 20 },
    widthTablet: { type: Number, default: 20 },
    widthDesktop: { type: Number, default: 20 },
    widthAuto: { type: Boolean, default: true },
    showMobile: { type: Boolean, default: true },
    showTablet: { type: Boolean, default: true },
    showDesktop: { type: Boolean, default: true }
  },
  data () {
    return {
      display: '',
      widthItem: 'auto',
      showItem: true
    }
  },
  mounted () {
    this.onInit(window.innerWidth)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setItemWidth (size) {
      if (size === 'sm' || size === 'xs') {
        return (this.widthMobile).toString() + '%'
      } else if (size === 'md') {
        return (this.widthTablet).toString() + '%'
      } else {
        return (this.widthDesktop).toString() + '%'
      }
    },
    setShowItem (size) {
      if (size === 'sm' || size === 'xs') {
        return this.showMobile
      } else if (size === 'md') {
        return this.showTablet
      } else {
        return this.showDesktop
      }
    },
    onResize () {
      if (window.innerWidth > 992) {
        this.display = 'lg'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else if (window.innerWidth > 768) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else if (window.innerWidth > 575) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else {
        this.display = 'sm'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      }
    },
    onInit (size) {
      if (size > 992) {
        this.display = 'lg'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else if (size > 768) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else if (window.innerWidth > 575) {
        this.display = 'md'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      } else {
        this.display = 'sm'
        this.showItem = this.setShowItem(this.display)
        if (!this.widthAuto) {
          this.widthItem = this.setItemWidth(this.display)
        }
      }
    }
  }
}

</script>
